export default __webpack_public_path__ + "static/media/WhatsApp-Logo.178a034c.png";